<template>
  <v-layout row>
    <v-flex md5 lg5>
      <CaseRegistrationStats :data="caseRegistrationStats"></CaseRegistrationStats>
    </v-flex>
    <v-flex md7 lg7>
      <GrossingByDoctors :data="grossingByDoctorsStats" class="ml-5"></GrossingByDoctors>
    </v-flex>
  </v-layout>
</template>

<script>
import CaseRegistrationStats from './CaseRegistrationStats'
import GrossingByDoctors from './GrossingByDoctors'
export default {
  name: 'FirstScreen',
  props: {
    caseRegistrationStats: {
      Type: Object
    },
    grossingByDoctorsStats: {
      Type: Object
    }
  },
  components: {
    CaseRegistrationStats,
    GrossingByDoctors
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Walldash/FirstScreen.vue